import React, { FC } from 'react';
import { ReactComponent as FacebookFIcon } from '../../../../assets/images/apps/FacebookF.svg';
import { ReactComponent as FacebookBigIcon } from '../../../../assets/images/apps/FacebookBig.svg';
import './FacebookIcon.scss';

interface FacebookIconProps {
  className: string;
  size?: string;
}

const defaultProps = {
  size: 'default',
};

export const FacebookIcon: FC<FacebookIconProps> = ({ className, size }) => {
  const getIcon = (type: string) => {
    switch (type) {
      case 'big': {
        return (
          <div className={`facebook-icon-container__big  ${className}`}>
            <FacebookBigIcon className="facebook-icon-container__big__icon" />
          </div>
        );
      }
      default: {
        return (
          <div className={`facebook-icon-container__small  ${className}`}>
            <FacebookFIcon className="facebook-icon-container__small__icon" />
          </div>
        );
      }
    }
  };

  return getIcon(size || defaultProps.size);
};

FacebookIcon.defaultProps = defaultProps;
